import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Col } from '@youngcapital/component-library';
import { Trans } from 'react-i18next';

import { AppContext } from '../../AppContext';
import Blokkendoos from '../../services/blokkendoos';

const SigninCard = ({ signupFor }) => {
  const { siteAbbr } = useContext(AppContext);

  const blokkendoos = new Blokkendoos();
  const croReplacements = ['YC', 'YC_DE', 'YC_UK'].find(
    elem => elem === siteAbbr
  );
  const showSigninCard = signupFor;
  const signInMethod = blokkendoos.getMetaContent('sign_in_method');
  const signInPath = blokkendoos.getMetaContent('sign_in_path');
  let signInLink;

  if (signInMethod === 'POST') {
    const csrfParam = blokkendoos.getMetaContent('csrf-param');
    const csrfToken = blokkendoos.getMetaContent('csrf-token');

    signInLink = (
      <form action={signInPath} method='POST'>
        <input type='hidden' name={csrfParam} value={csrfToken} />

        <Button>
          <Trans i18nKey='actions.login'>Login</Trans>
        </Button>
      </form>
    );
  } else {
    signInLink = (
      <a href={signInPath}>
        <Button>
          <Trans i18nKey='actions.login'>Login</Trans>
        </Button>
      </a>
    );
  }

  return (
    <>
      {showSigninCard && croReplacements && (
        <Card>
          <Trans i18nKey='fieldset_signin_card_no_link.text'>
            Do you have an account?
          </Trans>
          <Col style={{ marginTop: '12px' }}>{signInLink}</Col>
        </Card>
      )}
    </>
  );
};

SigninCard.propTypes = {
  signupFor: PropTypes.string.isRequired
};

export default SigninCard;
